import React, { useState, useEffect } from 'react';
import ReactInfiniteScroll from 'react-infinite-scroll-component';
import { LoadingState } from '@common/components';
import { Row } from 'antd';

export const InfiniteScroll = ({
  dataLength,
  next,
  height,
  elementClassName,
  children,
  hasMore,
  ...props
}: {
  dataLength: number;
  next: () => void;
  height?: number;
  elementClassName?: string;
  hasMore?: boolean;
  children: JSX.Element[];
}) => {
  const [divHeight, setDivHeight] = useState(height);

  useEffect(() => {
    if (elementClassName) {
      const element = document.querySelectorAll(elementClassName);

      setDivHeight(element[0]?.clientHeight);
    }
  }, [elementClassName]);

  if (!divHeight) {
    return <></>;
  }

  return (
    <>
      <div className="wk-infinite-scroll">
        <ReactInfiniteScroll
          dataLength={dataLength}
          next={next}
          hasMore={hasMore ?? !!dataLength}
          loader={
            <Row justify="center">
              <LoadingState size="md" />
            </Row>
          }
          height={divHeight}
          {...props}
        >
          {children}
        </ReactInfiniteScroll>
      </div>
      <style jsx>{`
        .wk-infinite-scroll {
          overflow: auto;
        }
      `}</style>
    </>
  );
};
